// The hashtag spellings a user allows, as an ordered list (`User.tag_styles`): the order is the preference, at least one stays.
import { TAG_STYLES, type TagStyle } from '@/todos/hashtags'

export interface TagStyleRow {
  style: TagStyle
  allowed: boolean
}

// Every spelling once: the allowed ones in their order, then the others in the default order.
export function styleRows(allowed: readonly TagStyle[]): TagStyleRow[] {
  return [
    ...allowed.map((style) => ({ style, allowed: true })),
    ...TAG_STYLES.filter((style) => !allowed.includes(style)).map((style) => ({ style, allowed: false })),
  ]
}

// Allows or forbids a spelling (a new one goes last); the last allowed spelling can not be forbidden (the list stays as it is).
export function toggleStyle(allowed: readonly TagStyle[], style: TagStyle): TagStyle[] {
  if (!allowed.includes(style)) return [...allowed, style]
  if (allowed.length <= 1) return [...allowed]
  return allowed.filter((other) => other !== style)
}

// Moves an allowed spelling one place up (-1) or down (+1).
export function moveStyle(allowed: readonly TagStyle[], style: TagStyle, by: -1 | 1): TagStyle[] {
  const from = allowed.indexOf(style)
  const to = from + by
  if (from < 0 || to < 0 || to >= allowed.length) return [...allowed]
  const next = [...allowed]
  next.splice(from, 1)
  next.splice(to, 0, style)
  return next
}
